import Swiper from '../../lib/swiper-core';

export const videoGalleries = document.querySelectorAll('.gallery-video, .gallery_row_video');

export class videoGallery {
  constructor() {
    videoGalleries.forEach(function (el) {
      console.log('Video gallery:', el);

      const videoGallery = new Swiper(el, {
        direction: 'horizontal',
        loop: true,
        speed: 600,
        grabCursor: true,
        centeredSlides: false,
        spaceBetween: 5,
        slidesPerView: 'auto',
        keyboard: {
          enabled: true,
        },
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // pagination: '.swiper-pagination',
        // paginationClickable: true,
        // nextButton: '.swiper-video-next',
        // prevButton: '.swiper-video-prev',
        preloadImages: false,
        lazyLoading: true,
        onInit: function (slide) {
          console.log('[media] gallery-video swiper init');
        }
      });
    });
  }
}

if (videoGalleries != undefined) new videoGallery();